import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useBlogContext } from '../Context/BlogContext';

function ProtectedRoutes({ component: Component, ...rest }) {
  const { authenticated } = useBlogContext();

  return (
    <Route
      {...rest}
      render={
        (props) =>
          authenticated ? <Component {...props} /> : <Redirect to='/login' />
        // users ? <Component {...props} /> : <Redirect to='/login' />
      }
    />
  );
}

export default ProtectedRoutes;
